/* 19 oktober 2026: alleen afspelen bij echte zichtbaarheid, ook na uitklappen. */
/*
 * Animaties in een productomschrijving.
 *
 * In elke omschrijving staan drie gifs. Samen ruim twee megabyte per pagina,
 * die ook nog eens meteen laadden terwijl ze ver onder de vouw staan.
 *
 * De sectie laat het adres van de gif staan maar vraagt de CDN om er een stil
 * beeld van te maken (format=jpg). Dat kost twintig kilobyte in plaats van
 * elfhonderd, en het is scherper dan de gif was. Dit script maakt daar een
 * video van; afspelen en laden wachten tot hij echt zichtbaar is.
 *
 * Zonder javascript, of met beweging uitgezet, blijft dat stilstaande beeld
 * staan. De pagina is dan lichter en de tekst eromheen vertelt hetzelfde.
 *
 * De naam van de video wordt afgeleid uit de naam van de gif, met dezelfde
 * regel als waarmee de bestanden zijn geupload: kleine letters, alles wat geen
 * letter of cijfer is wordt een streepje, en er komt film- voor. Zo hoeft er
 * nergens een lijstje bijgehouden te worden.
 *
 * Bestaat de video nog niet, dan valt het script terug op de gif zelf. Zo kan
 * het omzetten in etappes: elke geuploade mp4 maakt zijn animatie lichter,
 * zonder dat de rest stukgaat.
 *
 * 13 september 2026: autoplay op mobiel.
 *
 * Een geweigerde autoplay ving het script al stil op (de catch hieronder),
 * maar op mobiel bleef het dan bij een stilstaand eerste beeld staan: sommige
 * mobiele browsers wijzen play() af ook al staat muted er als attribuut op,
 * met name als de eigenschap zelf op dat moment nog niet is gezet. Nu zet
 * start() muted ook als eigenschap, vlak voor play(). Wijst de browser het
 * dan nog steeds af, dan probeert het script het opnieuw zodra de bezoeker de
 * pagina voor het eerst aanraakt of aanklikt: op dat moment telt de aanraking
 * als toestemming en mag hij wel spelen.
 *
 * 16 september 2026: pauze/afspeelknop rechtsonder, naar het voorbeeld van
 * Kopero's kopero-product-onder.liquid (het "duidelijke afspeelknop"-thema).
 *
 * Elke video komt nu in een eigen kadertje (rte-film-raam) met een klein rond
 * knopje rechtsonder om zelf te pauzeren of te hervatten. Wordt de automatische
 * start hierboven geweigerd (met name op mobiel), dan komt er in plaats
 * daarvan een groot, duidelijk afspeelknopje over het stilstaande beeld: twee
 * knoppen tegelijk (het kleine in de hoek en het grote in het midden) is
 * verwarrend, dus het kleine wacht dan even. Zodra de video voor het eerst
 * echt speelt (playing-event) verdwijnt het grote knopje voorgoed.
 *
 * De teksten bij de knoppen staan hier in het Nederlands, Engels, Duits,
 * Frans, Spaans, Portugees, Zweeds en Deens: dezelfde talen als de rest van de
 * winkel. document.documentElement.lang staat op de taal van de huidige markt
 * (zie layout/theme.liquid), dus dit bestand hoeft niet per taal te worden
 * aangepast.
 *
 * 25 september 2026: de drie gifs zijn uit de omschrijving gehaald (oude
 * branding, zie snippets/earthle-omschrijving.liquid) en op de plek van de
 * eerste staat nu de productvideo in de nieuwe branding, in 1080p en in de taal
 * van de markt.
 *
 * Die video komt niet uit een gif maar uit Liquid: sections/earthle-product-
 * verhaal zet per maat een leeg <div class="rte-film-plek"> neer met het adres
 * van de mp4, het stilstaande beeld en de afmetingen in data-attributen. Dit
 * script bouwt daar precies hetzelfde kadertje van als van een gif (video,
 * pauzeknop rechtsonder, groot afspeelknopje met tekst als autoplay wordt
 * geweigerd), zodat het er hetzelfde uitziet en zich hetzelfde gedraagt.
 * Verschillen met een gif: er is geen gif om op terug te vallen (een mislukte
 * mp4 laat gewoon het stilstaande beeld staan) en er staat een video per maat.
 * Alleen die van de gekozen maat is zichtbaar; kies je een andere maat, dan
 * wisselt het kadertje mee (zelfde principe als de handleidingknop in
 * earthle-handleiding). Een verborgen video laadt niet en wordt gepauzeerd.
 */
(function () {
  'use strict';

  var beelden = document.querySelectorAll('.rte img[src*=".gif"]');
  var plekken = document.querySelectorAll('.rte .rte-film-plek');
  if (!beelden.length && !plekken.length) return;

  var WOORDEN = {
    nl: { pauze: 'Video pauzeren', speel: 'Video afspelen' },
    en: { pauze: 'Pause video', speel: 'Play video' },
    de: { pauze: 'Video pausieren', speel: 'Video abspielen' },
    fr: { pauze: 'Mettre la vidéo en pause', speel: 'Lire la vidéo' },
    es: { pauze: 'Pausar el vídeo', speel: 'Reproducir el vídeo' },
    pt: { pauze: 'Pausar o vídeo', speel: 'Reproduzir o vídeo' },
    sv: { pauze: 'Pausa videon', speel: 'Spela upp videon' },
    da: { pauze: 'Sæt videoen på pause', speel: 'Afspil videoen' }
  };
  var taal = (document.documentElement.lang || 'nl').toLowerCase().slice(0, 2);
  var W = WOORDEN[taal] || WOORDEN.nl;

  function filmnaam(src) {
    var pad = src.split('?')[0];
    var map = pad.slice(0, pad.lastIndexOf('/') + 1);
    var basis = pad.slice(pad.lastIndexOf('/') + 1).replace(/\.gif$/i, '');
    basis = basis.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    return map + 'film-' + basis + '.mp4';
  }

  /*
    Bouwt het kadertje met video en knoppen en zet het in de plaats van `oud`
    (een gif of een plek uit Liquid). o: poster, mp4, gif (mag leeg zijn),
    breedte, hoogte, alt, verborgen.
  */
  function bouw(oud, o) {
    var raam = document.createElement('div');
    raam.className = 'rte-film-raam';
    if (o.variant) raam.setAttribute('data-variant', o.variant);
    if (o.verborgen) raam.hidden = true;

    var v = document.createElement('video');
    v.className = 'rte-film';
    v.muted = true;
    v.defaultMuted = true;
    v.loop = true;
    v.playsInline = true;
    v.setAttribute('muted', '');
    v.setAttribute('loop', '');
    v.setAttribute('playsinline', '');
    v.setAttribute('preload', 'none');
    v.setAttribute('poster', o.poster);
    if (o.breedte) v.setAttribute('width', o.breedte);
    if (o.hoogte) v.setAttribute('height', o.hoogte);
    if (o.alt) v.setAttribute('aria-label', o.alt);
    v.dataset.mp4 = o.mp4;
    v.dataset.gif = o.gif || '';
    v.dataset.alt = o.alt || '';

    var knop = document.createElement('button');
    knop.type = 'button';
    knop.className = 'rte-film-knop';
    knop.setAttribute('aria-label', W.pauze);
    knop.innerHTML =
      '<svg class="rte-film-ico-pauze" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M7 5h3.5v14H7zM13.5 5H17v14h-3.5z"/></svg>' +
      '<svg class="rte-film-ico-speel" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5.5v13l11-6.5z"/></svg>';

    var start = document.createElement('button');
    start.type = 'button';
    start.className = 'rte-film-start';
    start.setAttribute('aria-label', W.speel);
    start.innerHTML =
      '<span class="rte-film-start-rond"><svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5.5v13l11-6.5z"/></svg></span>' +
      '<span class="rte-film-start-tekst">' + W.speel + '</span>';

    raam.appendChild(v);
    raam.appendChild(start);
    raam.appendChild(knop);
    oud.parentNode.replaceChild(raam, oud);

    function staat() {
      raam.classList.toggle('is-gepauzeerd', v.paused);
      knop.setAttribute('aria-label', v.paused ? W.speel : W.pauze);
    }
    v.addEventListener('playing', function () { raam.classList.remove('is-wacht'); });
    v.addEventListener('play', staat);
    v.addEventListener('pause', staat);
    staat();

    knop.addEventListener('click', function () {
      if (v.paused) {
        delete v.dataset.handmatig;
        start(v);
      } else {
        v.dataset.handmatig = '1';
        v.pause();
      }
    });
    start.addEventListener('click', function () {
      delete v.dataset.handmatig;
      start(v);
    });

    return v;
  }

  function maakVideo(beeld) {
    var src = beeld.getAttribute('src') || '';
    if (src.indexOf('.gif') === -1) return null;
    return bouw(beeld, {
      poster: src,
      mp4: filmnaam(src),
      gif: src.replace('format=jpg&', ''),
      breedte: beeld.getAttribute('width'),
      hoogte: beeld.getAttribute('height'),
      alt: beeld.alt || ''
    });
  }

  function maakVideoUitPlek(plek) {
    if (!plek.dataset.mp4) return null;
    return bouw(plek, {
      poster: plek.dataset.poster || '',
      mp4: plek.dataset.mp4,
      gif: '',
      breedte: plek.dataset.breedte,
      hoogte: plek.dataset.hoogte,
      alt: plek.dataset.alt || '',
      variant: plek.dataset.variant || '',
      verborgen: plek.hasAttribute('data-verborgen')
    });
  }

  /*
    Geen video op dat adres. Dan zetten we de gif terug, met loading lazy erop,
    zodat hij nog steeds niet meelaadt met de rest van de pagina. Het hele
    kadertje (met de knoppen erin) gaat er dan uit, niet alleen de video zelf.
    Een video zonder gif (de productvideo) blijft gewoon staan met zijn
    stilstaande beeld.
  */
  function terugNaarGif(v) {
    if (!v.dataset.gif) return;
    var img = document.createElement('img');
    img.src = v.dataset.gif;
    img.alt = v.dataset.alt;
    img.loading = 'lazy';
    img.decoding = 'async';
    if (v.getAttribute('width')) img.setAttribute('width', v.getAttribute('width'));
    if (v.getAttribute('height')) img.setAttribute('height', v.getAttribute('height'));
    var raam = v.closest('.rte-film-raam');
    var doel = raam || v;
    if (doel.parentNode) doel.parentNode.replaceChild(img, doel);
  }

  /*
    Zodra de bezoeker de pagina voor het eerst aanraakt of aanklikt, telt dat
    als toestemming voor geluid en beweging. We proberen dan alle video's die
    tot dan toe geweigerd zijn nog een keer, en luisteren daarna niet meer.
  */
  var wachtOpAanraking = [];
  function probeerBijAanraking(v) {
    wachtOpAanraking.push(v);
    if (wachtOpAanraking.length > 1) return;

    function opnieuw() {
      document.removeEventListener('touchstart', opnieuw);
      document.removeEventListener('click', opnieuw);
      wachtOpAanraking.forEach(function (video) {
        var raam = video.closest('.rte-film-raam');
        if (video.dataset.handmatig || !EarthleVideoVisibility.isVisible(video)) return;
        video.muted = true;
        var poging = video.play();
        if (poging && poging.catch) poging.catch(function () {});
      });
      wachtOpAanraking = [];
    }
    document.addEventListener('touchstart', opnieuw, { once: true, passive: true });
    document.addEventListener('click', opnieuw, { once: true });
  }

  function start(v) {
    if (v.dataset.handmatig || !EarthleVideoVisibility.isVisible(v)) return;
    if (!v.dataset.aan) {
      v.dataset.aan = '1';
      var mp4 = document.createElement('source');
      mp4.src = v.dataset.mp4;
      mp4.type = 'video/mp4';
      mp4.addEventListener('error', function () { terugNaarGif(v); });
      v.appendChild(mp4);
      v.load();
    }
    v.muted = true;
    var poging = v.play();
    if (poging && poging.catch) {
      poging.catch(function () {
        if (v.dataset.handmatig || !EarthleVideoVisibility.isVisible(v)) return;
        probeerBijAanraking(v);
        var raam = v.closest('.rte-film-raam');
        if (raam) raam.classList.add('is-wacht');
      });
    }
  }

  var films = [];
  Array.prototype.forEach.call(beelden, function (beeld) {
    var v = maakVideo(beeld);
    if (v) films.push(v);
  });
  Array.prototype.forEach.call(plekken, function (plek) {
    var v = maakVideoUitPlek(plek);
    if (v) films.push(v);
  });
  if (!films.length) return;

  /*
    De productvideo volgt de gekozen maat. De maatknoppen bovenaan de pagina
    hebben data-variant (het variant-id), en het bestelblok verderop heeft een
    keuzelijst met name="id". Een andere maat toont het kadertje van die maat
    en pauzeert de rest, zodat er nooit twee tegelijk lopen.
  */
  function toonMaat(id) {
    if (!id) return;
    Array.prototype.forEach.call(document.querySelectorAll('.rte-film-raam[data-variant]'), function (raam) {
      var aan = raam.getAttribute('data-variant') === String(id);
      raam.hidden = !aan;
      var vid = raam.querySelector('video');
      if (!vid) return;
      if (!aan) {
        if (!vid.paused) vid.pause();
      }
      EarthleVideoVisibility.refresh();
    });
  }
  if (document.querySelector('.rte-film-raam[data-variant]')) {
    document.addEventListener('click', function (e) {
      var k = e.target.closest ? e.target.closest('[data-variant]') : null;
      if (!k || k.classList.contains('rte-film-raam')) return;
      toonMaat(k.getAttribute('data-variant'));
    });
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.name === 'id' && t.value) toonMaat(t.value);
    });
  }

  var rustig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  films.forEach(function (v) {
    if (rustig) {
      v.dataset.handmatig = '1';
      var raam = v.closest('.rte-film-raam');
      if (raam) raam.classList.add('is-wacht');
    }
    EarthleVideoVisibility.register(v, function () { start(v); });
  });
})();
